// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 30px;
}
h1 {
  color: #353535;
  font-size: 36px;
  font-weight: bold;
}
p {
  color: #353535;
  font-size: 18px;
  font-weight: 300;
}
`, "",{"version":3,"sources":["webpack://./src/app/Controls/App/LayoutContent/Open/ContentOpenHeader.less"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;AADF;AAIA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;AAFF;AAKA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAHF","sourcesContent":["@import '~common-controls/Style/Colors.less';\n\n.wrapper {\n  width: 100%;\n  margin-top: 10px;\n  margin-bottom: 30px;\n}\n\nh1 {\n  color: @text-gray1;\n  font-size: 36px;\n  font-weight: bold;\n}\n\np {\n  color: @text-gray1;\n  font-size: 18px;\n  font-weight: 300;\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
